import React, {useRef, useState} from 'react';

import "./CreateFolder.scss";
import UniversalButton from "../../uiComponents/UniversalButton";

const CreateFolder = ({closeCreateFolderModal, currentFolderName, addOrEditFolder, type}) => {

  const input = useRef();

  const [isError, setError] = useState(null);
  const [folderName, setFolderName] = useState(type === "create" ? "" : currentFolderName);

  const createFolder = () => {

    try {
      addOrEditFolder(folderName);
      setError(null);
      closeCreateFolderModal();
    } catch(error) {
      setError(error)
    }
  }

  const editFolder = () => {

    const newNameFolder = folderName;
    const originalNameFolder = currentFolderName;

    try {
      addOrEditFolder(originalNameFolder, newNameFolder);
      setError(null);
      closeCreateFolderModal();
    } catch(error) {
      setError(error)
    }
  }

  return (
    <div className="create-folder">
      <div className="create-folder__header">{`${type === "create" ? "Create" : "Edit" } folder`}</div>
      <div className="create-folder__input">
        <input type="text" ref={input} c
               className={isError ? "create-folder__input-error" : ""}
               value={folderName}
               onInput={(event) => setFolderName(event.target.value)} />
        {
          isError ? <div className="create-folder__error-text">{isError}</div> : null
        }
      </div>
      <div className="save-template__btns">
        <div className="save-template__btns_btn">
          <UniversalButton
            type="button"
            label="Cancel"
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={closeCreateFolderModal}
          />
        </div>

        <UniversalButton
          type="button"
          label={type === "create" ? "Create" : "Save" }
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={type === "create" ? createFolder : editFolder}
        />
      </div>
    </div>
  );
};

export default CreateFolder;